import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import { Helmet } from 'react-helmet';
import getMessage from '../../utils/getMessage';

function PleaseLoginToJoinHearing({login, register}) {
  return (
    <div className="please-login-container">
      <Helmet title={getMessage("loginToContinue")}/>
      <h1><FormattedMessage id="loginToContinue"/></h1>
      <p className="please-login-info-text"><FormattedMessage id="onlyLoggedInMayJoin"/></p>
      <p className="please-login-info-text strong"><FormattedMessage id="noAccountHelpText"/></p>
      <div className="please-login-button-container">
        <button className="digi-button" onClick={login}><FormattedMessage id="login"/></button>
        <button className="digi-button" onClick={register}><FormattedMessage id="register"/></button>
      </div>
    </div>
  );
}

PleaseLoginToJoinHearing.propTypes = {
  login: PropTypes.func,
};

export default PleaseLoginToJoinHearing;
